// Nhập lý do bắt buộc (từ chối duyệt / thu hồi tài liệu)
import { useEffect, useRef, useState } from 'react';
import { Input, Modal } from 'antd';
import type { TextAreaRef } from 'antd/es/input/TextArea';

interface Props {
  open: boolean;
  title: string;
  description?: React.ReactNode;
  okText: string;
  danger?: boolean;
  minLength?: number;
  onCancel: () => void;
  onOk: (reason: string) => void;
}

export default function ReasonModal({ open, title, description, okText, danger, minLength = 10, onCancel, onOk }: Props) {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);
  const ref = useRef<TextAreaRef>(null);
  useEffect(() => { if (open) { setReason(''); setTouched(false); } }, [open]);
  const error = reason.trim().length < minLength ? `Lý do tối thiểu ${minLength} ký tự` : null;

  const submit = () => {
    setTouched(true);
    if (!error) onOk(reason.trim());
  };

  return (
    <Modal
      open={open} title={title} okText={okText} cancelText="Hủy" onCancel={onCancel} onOk={submit} centered destroyOnHidden
      okButtonProps={{ danger }} afterOpenChange={o => o && ref.current?.focus()}
    >
      {description && <div className="mb-3 text-sm text-slate-600">{description}</div>}
      <Input.TextArea
        ref={ref} rows={4} maxLength={500} showCount value={reason} onChange={e => setReason(e.target.value)}
        placeholder="Nhập lý do…" status={touched && error ? 'error' : undefined}
      />
      {touched && error && <div className="mt-1 text-sm text-red-600">{error}</div>}
    </Modal>
  );
}
